import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Component,
  Input
} from '@angular/core';
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { ErrorMessageService } from '@core/service/error-message.service';
import { AuthService } from '@core/service/auth.service';
import { IntegerFormatPipe } from '@core/pipe/integer-format.pipe';
import moment from 'moment';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';

export interface DialogData {
  id: number;
  action: string;
  item: any;
}

// ✅ Define French locale globally
defineLocale('fr', frLocale);

@Component({
  selector: 'app-shopping-article',
  standalone: true, // Add this for standalone components
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    // Uncomment this
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatTabsModule,
    // Add MatTabsModule here
    IntegerFormatPipe,
    BsDatepickerModule
  ],
  templateUrl: './shopping-article.component.html',
  styleUrl: './shopping-article.component.scss'
})
export class ShoppingArticleComponent {
  @Input() data: any = {};
  action!: string;
  dialogTitle!: string;
  itemToSave: any = {};
  isLoading: boolean = false;
  user: any;
  currentPage: number | undefined;
  loading: boolean | undefined;
  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  } | undefined;
  endPoint: string = "commande";
  title = 'commande boutique'
  createMessage = ''
  editMessage = ''
  deleteMessage = ''
  gender = 'M'
  programme_article_id: any
  itemsTypeChambre: any = [];
  itemsCommodite: any = [];
  itemToAddCommodite: any = {};
  itemsCommoditeToSave: any = [];

  itemToAddArticle: any = {};
  itemsArticle: any = [];
  itemsImage: any = [];
  itemsImagesChambreToSave: any;
  itemsMenuProgramme: any = [];
  itemsCommandeDetailToSave: any = [];
  client_search_key: any;
  itemsClient: any;
  itemsHebergement: any = [];
  itemsTypeCommande: any;
  selected_item: any;
  defaultImage: string = '/assets/images/default-product.png'; // Add a default image path

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private errorMessage: ErrorMessageService,
    private authService: AuthService,
    private localeService: BsLocaleService // Add dialogRef
  ) {
    // Set the defaults
    if (this.action === 'edit') {
      this.dialogTitle = '';
      this.itemToSave = {
      };

      this.itemToSave.date_effet = moment(this.itemToSave.date_effet).toDate()
      this.itemToSave.date_fin = moment(this.itemToSave.date_fin).toDate()
      console.log("this.itemToSave: ", this.itemToSave)
      }
      this.getItemsMenuProgramme()
    }

  ngOnInit(): void {
    this.action = this.data?.action;
    console.log('this.data: ', this.data)
    if (this.data.item?.image_url) {
    this.imageDisplay = this.data.item?.image_url;
  } else {
      this.dialogTitle = ' ';
      this.itemToSave = {}
    }
    this.user = this.authService.getCurrentUser()

    let text1 = this.gender == 'M' ? 'un' : 'une'
    this.createMessage = 'Vous êtes sur le point de créer ' + text1 + ' ' + this.title
    this.editMessage = 'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title
    this.deleteMessage = 'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title
    this.localeService.use('fr');
    this.getItemsArticle()
  }

  getItemsMenuProgramme() {
    let request = {
      extra_control: [
        {
          key: 'date_effet',
          value: new Date(),
          sign: '<'
        },
        {
          key: 'date_fin',
          value: new Date(),
          sign: '>'
        }
      ],
      data: {
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("menuProgramme/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsMenuProgramme = res["items"];
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsMenuProgramme = [];
          }
        },
        (err) => {
          this.itemsMenuProgramme = [];
        }
      );
  }

  getItemsArticle() {
    let request = {
      add_stock_info: true,
      is_for_commande_boutique:true,
      data: {
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("article/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsArticle = res["items"];
            console.log("this.itemsArticle: ", this.itemsArticle)
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsArticle = [];
          }
        },
        (err) => {
          this.itemsArticle = [];
        }
      );
  }

  trackById(index: number, article: any): string {
    return article.id;
  }

  addToCart(article: any): void {
    if (article.quantite_en_stock > 0) {
      console.log('Adding to cart:', article);
      this.utilities.showNotification(
        'snackbar-success',
        `Ajouté « ${article.title} » au panier.`,
        'bottom',
        'center'
      );
    }
  }

  // Add close method
  closeDialog(): void {
    this.activeModal.close();
  }

  cartItems: any[] = [];

toggleSelection(article: any): void {
  const existing = this.cartItems.find(item => item.id === article.id);
  if (existing) {
    existing.quantity += 1;
  } else {
    this.cartItems.push({ ...article, quantity: 1 });
  }
}

isSelected(article: any): boolean {
  return this.cartItems.some(item => item.id === article.id);
}

getTotal(): number {
  return this.cartItems.reduce((sum, item) => sum + item.prix_vente * item.quantity, 0);
}

clearCart(): void {
  this.cartItems = [];
}

validateCart(): void {
  Swal.fire({
    icon: 'success',
    title: 'Commande validée',
    text: `Total: ${this.getTotal()} FCFA`,
  });
  this.closeDialog();
}

increaseQuantity(article: any): void {
  const existing = this.cartItems.find(item => item.id === article.id);
  const maxAllowed = article.quantite_en_stock;

  // If no stock allowed (i.e., max ≤ 0), do nothing.
  if (!maxAllowed || maxAllowed <= 0) {
    return;
  }

  if (existing) {
    // If already at max allowed, do nothing.
    if (existing.quantity >= maxAllowed) {
      return;
    }
    existing.quantity += 1;
  } else {
    // Add new item, quantity starts at 1 (which is ≤ maxAllowed)
    this.cartItems.push({ ...article, quantity: 1 });
  }
}


decreaseQuantity(article: any): void {
  const existing = this.cartItems.find(item => item.id === article.id);
  if (existing) {
    existing.quantity -= 1;
    if (existing.quantity <= 0) {
      this.cartItems = this.cartItems.filter(item => item.id !== article.id);
    }
  }
}

getQuantity(article: any): number {
  const existing = this.cartItems.find(item => item.id === article.id);
  return existing ? existing.quantity : 0;
}

  isInCart(article: any): boolean {
    return this.cartItems.some(item => item.id === article.id);
  }

}